import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking
  const [couple, setCouple] = useState(null);
  const [partner, setPartner] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      try {
        const c = await api.get("/couple/me");
        setCouple(c.data.couple);
        setPartner(c.data.partner);
      } catch (e) {
        setCouple(null);
        setPartner(null);
      }
      return data;
    } catch (e) {
      setUser(false);
      setCouple(null);
      setPartner(null);
      return null;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("token", data.access_token);
    setUser(data.user);
    await refresh();
    return data.user;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    if (data.access_token) localStorage.setItem("token", data.access_token);
    setUser(data.user);
    await refresh();
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // ignore
    }
    localStorage.removeItem("token");
    setUser(false);
    setCouple(null);
    setPartner(null);
  };

  return (
    <AuthContext.Provider value={{ user, couple, partner, login, register, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
